/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_settings_debug_vscodenomessenger2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VS Code 메신저가 없습니다`)
};

const en_settings_debug_vscodenomessenger2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VS Code messenger not available`)
};

const ja_settings_debug_vscodenomessenger2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VS Codeメッセンジャーが利用できません`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const settings_debug_vscodenomessenger2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_debug_vscodenomessenger2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_debug_vscodenomessenger2", locale)
	if (locale === "ko") return ko_settings_debug_vscodenomessenger2(inputs)
	if (locale === "en") return en_settings_debug_vscodenomessenger2(inputs)
	return ja_settings_debug_vscodenomessenger2(inputs)
};
export { settings_debug_vscodenomessenger2 as "settings_debug_vscodeNoMessenger" }